import { Component, OnInit,ViewChild } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../../../../services/common-data.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-seller-orders-dynamic',
  templateUrl: './seller-orders-dynamic.component.html',
  styleUrls: ['./seller-orders-dynamic.component.css']
})
export class SellerOrdersDynamicComponent implements OnInit {

  pageName = "Shop Orders";
  modelData: any;
  modelName = 'Sale';
  modelId = '0';
  sellerActiveSales
  tableData = []

  displayedColumns: string[] = ['transactionRef', 'goodsCollectionForPackageDueDate', 'collectionFromSellerStatus', 'totalAmount', 'view'];
  // dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  dataSource
  ready =false

  ordersStatusFilter = ""

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private router: Router, 
    private formBuilder: FormBuilder, 
    private _data: CommonDataService,
    private route: ActivatedRoute
  ) { 

  }

  ngOnInit() {
    // this.dataSource.paginator = this.paginator;
    this.ordersStatusFilter = this.route.snapshot.paramMap.get('type');
    this.getSales();
  }

  getSales() {
    let userId = sessionStorage.getItem('context')

    if(!userId) {
        $('#loader').hide();
        // redirect to login 
        return false;
    }

    // http.get('http://jsonplaceholder.typicode.com/users/')
    //     .flatMap((response) => response.json())
    //     .filter((person) => person.id > 5)
    //     .map((person) => "Dr. " + person.name)
    //     .subscribe((data) => {
    //       this.doctors.push(data);
    //     });

    let modelObject1 = new FormData();
    modelObject1.append('modelName', this.modelName);
    // modelObject1.append('objectName', 'businessDetails');
    modelObject1.append('context_id', userId);

    $('#loader').show();
    //lets get the model for this page
        this._data.getModelData(modelObject1) 
        // .pipe(first())
        .subscribe(
          data => {
            console.log(data);
            this.modelData = data['covers'];
            this.sellerActiveSales = this.filterActiveSales()

            // for (let index = 0; index < this.sellerActiveSales.length; index++) {
            //   const element = this.sellerActiveSales[index];

            //   this.tableData.push(element['cover']['model']['modelData']['systemManagedEntities']['saleDetails'])
              
            // }

            this.dataSource = new MatTableDataSource<any>(this.sellerActiveSales);
            this.dataSource.paginator = this.paginator;
            this.ready = true

            console.log(this.sellerActiveSales)
          },
          error => {

            console.log(error);
            iziToast.success({
              title: 'Error!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Failed to retrieve your active sales.'
          });

          $('#loader').hide();

          },

          () => {
              $('#loader').hide();
          }
      );

  }

  filterActiveSales() {
    let returnData = this.modelData;
    // return this.modelData
    switch (this.ordersStatusFilter) {
      case "all":
        returnData = this.modelData;
        break;

      case "new":
        returnData =  this.modelData.filter(prod => prod['cover']['model']['modelData']['systemManagedEntities']['saleDetails']['collectionFromSellerStatus'] === "PENDING"); 
        break;

      case "deliveries":
        returnData =  this.modelData.filter(prod => prod['cover']['model']['modelData']['systemManagedEntities']['saleDetails']['collectionFromSellerStatus'] === "READYFORDELIVERY"); 
        break;

      case "collections":
        returnData =  this.modelData.filter(prod => prod['cover']['model']['modelData']['systemManagedEntities']['saleDetails']['collectionFromSellerStatus'] === "READYFORCOLLECTION"); 
        break;

      case "completed":
        returnData =  this.modelData.filter(prod => prod['cover']['model']['modelData']['systemManagedEntities']['saleDetails']['collectionFromSellerStatus'] === "DELIVERED"); 
        break;
    
      default:
        break;
    }
    // return this.modelData.filter(prod => prod['cover']['model']['modelData']['systemManagedEntities']['saleDetails']['collectionFromSellerStatus'] === "PENDING");
    
    return returnData
  }

  routeIdParam(id)
  {
    // alert(id)
    this.queryParamsSet({saleId: id});
  	// this.router.navigate(['/sellers/account/create-product']);
  }

  queryParamsSet(dataParams: any) {
    this._data.queryParamsChanged.next(dataParams);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


}


